
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>课程中心</span><span>/</span><span @click="goBack">{{flag=='2'?'自研课程':'已购课程'}}</span><span>/</span><span>课程明细</span></div>

    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="cname" fixed label="名称">
        </el-table-column>
        <el-table-column prop="author" width="80" label="讲师">
        </el-table-column>
        <el-table-column prop="xstime" width="160" label="时长">
        </el-table-column>
        <el-table-column prop="ks" width="80" label="课时">
        </el-table-column>
        <el-table-column prop="begintime" width="160" label="开始时间">
          <template slot-scope="scope">
            <span>{{scope.row.begintime?scope.row.begintime.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="endtime" width="160" label="结束时间">
          <template slot-scope="scope">
            <span>{{scope.row.endtime?scope.row.endtime.substring(0,10):''}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          currId: '',
          page: 1,
          rows: 10
        },
        tableData: {
          rows: [],
          total: 0
        },
flag:'',
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/wz/productInfo/getKcByCurrId.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      goBack:function(){
        this.$router.go(-1);
      }
    },
    created: function() {
      this.$set(this.formInline, 'currId', this.$route.query.id);
      this.flag = this.$route.query.flag;
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Mingxi.vue